import React, { useState, useEffect, useMemo } from "react"
import Rem_filter_page from "../layout/header";
import axios from "axios";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReviewSuccess from "./reviewSuccess";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

function ReviewSecondSection(props) {
    const { t, i18n } = useTranslation('common');
   
    useEffect(() => {
        window.scroll(0, 0);
        if (props?.lan == 'en') {
            i18next.changeLanguage("en");
        } else {
            i18next.changeLanguage("el");
        }
    }, [])

    var otp_inputs = document.querySelectorAll(".otp__digit")
    var mykey = "0123456789".split("")
    otp_inputs.forEach((_) => {
        _.addEventListener("keyup", handle_next_input)
    })
    
    function handle_next_input(event) {
        let current = event.target
        let index = parseInt(current.classList[1].split("__")[2])
        current.value = event.key

        if (event.keyCode == 8 && index > 1) {
            current.previousElementSibling.focus()
        }
        if (index < 6 && mykey.indexOf("" + event.key + "") != -1) {
            var next = current.nextElementSibling;
            next.focus()
        }
        var _finalKey = ""
        for (let { value } of otp_inputs) {
            _finalKey += value
        }
       
        if (_finalKey.length == 6) {
            // document.querySelector("#_otp").classList.replace("_notok", "_ok")
            // document.querySelector("#_otp").innerText = _finalKey;
        
          
           // console.log("1"+_finalKey);
        } else {
            // document.querySelector("#_otp").classList.replace("_ok", "_notok")
            // document.querySelector("#_otp").innerText = _finalKey
           
          // console.log("2"+_finalKey);
        }
    }

    function set_url(path) {
        return props?.site_url+path;
    }
    const [isShown, setIsShown] = useState(false);
    const [first_name, setfname] = useState('');
    const [last_name, set_lname] = useState('');
    const [mobile_no, set_mobile] = useState('');
    const [email, setemail] = useState('');
    const [setotp, setotp_veri] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [otp1_val, setotp_1] = useState('');
    const [otp2_val, setotp_2] = useState('');
    const [otp3_val, setotp_3] = useState('');
    const [otp4_val, setotp_4] = useState('');
    const [otp5_val, setotp_5] = useState('');
    const [otp6_val, setotp_6] = useState('');



    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);


    const handleShow = () => setShow(true);


    const handleChange = event => {
        const name = event.target.getAttribute('name');

        switch (name) {
            case 'first_name':
                setfname(event.target.value);
                break;
            case 'rem_last_name':
                set_lname(event.target.value);
                break;
            case 'mobile_no':
                set_mobile(event.target.value);
                break;
            case 'email':
                setemail(event.target.value);
                break;
            case 'vehicle1':

                if (event.target.checked) {
                 
                    setIsSubscribed("checked");


                } else {
                  
                    setIsSubscribed("notchecked");

                }

                break;
            case 'otp_verify':
                setotp_veri(event.target.value);
                break;
            case 'otp_1':
                setotp_1(event.target.value);
                break;
            case 'otp_2':
                setotp_2(event.target.value);
                break;
            case 'otp_3':
                setotp_3(event.target.value);
                break;
            case 'otp_4':
                setotp_4(event.target.value);
                break;
            case 'otp_5':
                setotp_5(event.target.value);
                break;
            case 'otp_6':
                setotp_6(event.target.value);
                break;
        }

    };
   
    const SendClick = event => {
        const is_desabled1 = event.target.getAttribute('disabled');
        if (is_desabled1 != null) {
            return false;
        }
        event.preventDefault();
        setSubmitted(true)
        // console.log(isAnonymous);



        const data = {
            'rem_find_trader': props?.btn1,
            'rem_recommend_trader': props?.btn2,
            'post_id': props?.post_id,
            'first_name': first_name,
            'last_name': last_name,
            'mobile_No': mobile_no,
            'email': email,
            'initial_impression': props?.rating1,
            'Punctuality_rating': props?.rating2,
            'Cleanliness_rating': props?.rating3,
            'quality_rating': props?.rating4,
            'Value_rating': props?.rating5,
            'overall_rating': props?.rating6,
            'user_comments': props?.user_message,
        }
        const is_desabled = event.target.getAttribute('disabled');

        if (!first_name || !last_name || !mobile_no || !email || is_desabled != null || !isSubscribed) {
            return false;
        }
        if (data && isSubscribed == "checked") {

            axios.post(set_url("/wp-json/myapi/v1/sendreview"), data).then((response) => {
                if (!response.errors) {
                    if (props?.lan == 'en') {
                        const url = props?.site_url + '/en/thankyou-section';
                        window.location.href = url;
                    }
                    else {
                        const url = props?.site_url + '/thankyou-page';
                        window.location.href = url;
                    }

                    //setIsShown(current => !current);        
                    //alert("sended your review");
                    //   const url = props?.site_url + '/professionals';
                    //  window.location.href = url;


                }
            });
        }



    };


    return (
        <div>

            <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js"></script>
            <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/js/bootstrap.min.js"></script>


            <div class="review_body" id="review_second_section">

                <section class="main_review_section">
                    <div class="container_review_main">
                        <div class="row">
                            <div class="main_review_box">
                                <h2>{t('We just need your details now')}</h2>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="mt-5">
                    <div class="container_review_main">
                        <form>
                            <div class="row">
                                <div class="col-xl-4 col-lg-4 col-md-4">
                                    <div class="review_form_input">
                                        <input type="text" onChange={handleChange} name="first_name" placeholder={t('First Name')} />
                                        {(first_name == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
                                            <p></p>}
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-4 col-md-4">
                                    <div class="review_form_input last_name_review">
                                        <input type="text" name="rem_last_name" onChange={handleChange} placeholder={t('Last Name')} />
                                        {(last_name == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
                                            <p></p>}
                                    </div>
                                </div>
                                <p class="leave_reave_paira col-12">{t("Only the first letter of your last name will appear against your review on the trader's public profile page .")}</p>

                                <div class="col-xl-5 col-lg-5 col-md-5 mt-3">
                                    <div class="review_form_input">
                                        <input type="number" id="remPhoneNumber" name="mobile_no" onChange={handleChange} placeholder={t('Mobile Number')} />

                                        <span id="phone_verify_msg" class="phone_verify_msg rem_hide">{t('Mobile number verified')}</span>
                                        {(mobile_no == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
                                            <p></p>}
                                    </div>
                                </div>
                                <p class="leave_reave_paira col-12">{t("We'll send a verification code to your mobile number .")}</p>

                                <div class="verify_btn_leave col-12 mb-4">
                                    <a id="remVerifyCode" href="#" data-toggle="modal" data-target="#myModal" >{t('Verify')}</a>

                                    <img src="https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca_w200.gif" class="rem_hide" id="rem_code_verify_loader" />
                                    <small class="rem_code_error_message rem_hide">
                                        Please enter valid verification code
                                    </small>
                                    <Button class="rem_model" onClick={handleShow} hidden>
                                        Launch demo modal
                                    </Button>

                                    <Modal show={show} onHide={handleClose}>
                                        <Modal.Body class="modal_view">
                                            <form action="javascript: void(0)" class="otp-form" name="otp-form">

                                                <div class="title">
                                                    <h3>{t('OTP VERIFICATION')}</h3>

                                                    <p class="msg" >{t('Please enter OTP to verify')}</p>
                                                </div>
                                                <div class="otp-input-fields">
                                                    <input type="number" class="otp__digit otp__field__1" name="otp_1" onChange={handleChange} id="otp1_id"  />
                                                    <input type="number" class="otp__digit otp__field__2" name="otp_2" onChange={handleChange} id="otp2_id"/>
                                                    <input type="number" class="otp__digit otp__field__3" name="otp_3" onChange={handleChange} id="otp3_id"  />
                                                    <input type="number" class="otp__digit otp__field__4" name="otp_4" onChange={handleChange} id="otp4_id" />
                                                    <input type="number" class="otp__digit otp__field__5" name="otp_5" onChange={handleChange} id="otp5_id" />
                                                    <input type="number" class="otp__digit otp__field__6" name="otp_6" onChange={handleChange} id="otp6_id"  />
                                                </div>
                                               
                                                {/* <div class="result"><p id="_otp" class="_notok"></p></div> */}
                                                <Button variant="primary send_data" onClick={handleClose}>
                                                    {t('Send')}
                                                </Button>
                                            </form>

                                        </Modal.Body>

                                    </Modal>
                                </div>

                                <div class="col-xl-6 col-lg-6 col-md-6">
                                    <div class="review_form_input">
                                        <input type="email" name="email" onChange={handleChange} placeholder="E-mail" />
                                        {(email == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
                                            <p></p>}
                                    </div>
                                </div>
                                <p class="leave_reave_paira col-12">{t('We may also contact you by email if we have any questions regarding your submission .')}</p>

                                <p class="leave_reave_paira col-12">{t('Your details will not be passed to any other party or used for any purpose other than to possibly contact you regarding validation of your review.')}</p>

                                <div class="terms_container_check col-12">
                                    <input type="checkbox" id="" name="vehicle1" onChange={handleChange} value={isSubscribed} />
                                    <label for="vehicle1">{t('I agree with the ')}<a href="https://tamastoria.gr/terms-and-conditions/">{t('Terms &amp; Conditions')}</a> {t('of this website.')}</label>
                                </div>
                                {(isSubscribed == '' && submitted) ? <p className="ratingFormValidation">{t('Required')}</p> :
                                    <p></p>}

                                <div class="verify_btn_leave send_review_btn col-12 Send_btn">
                                    <a id="rem_submit" href="#" disabled onClick={SendClick} >{t('Send')}</a>
                                </div>

                            </div>
                        </form>
                    </div>
                </section>
            </div>

        </div>);



}
export default ReviewSecondSection;
